import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Button from '../../components/reusable/button/button.component';
import FulfillmentDisplay from '../../components/fulfillment/fulfillment-display/fulfillment-display.component';
import Spinner from '../../components/reusable/spinner/spinner.component';
import UpdateFulfillment from '../../components/fulfillment/update-fulfillment/update-fulfillment.component';

import Client from '../../tools/client';

import {
  BackLink,
  ButtonGroup,
  MainContainer
} from '../../styles/page.styles';

const client = new Client();

const FulfillmentPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [fulfillment, setFulfillment] = useState(null);
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    getFulfillment();
  }, [id]);

  const getFulfillment = async () => {
    setLoading(true);
    const res = await client.getFulfillmentById(id);
    
    setFulfillment(res);
    setLoading(false);
  };

  const renderContent = () => {
    if (showUpdate) {
      return (
        <UpdateFulfillment
          fulfillment={fulfillment}
          setShowEdit={setShowUpdate}
          getFulfillment={getFulfillment}
        />
      );
    }

    return (
      <FulfillmentDisplay
        fulfillment={fulfillment}
        getFulfillment={getFulfillment}
        setShowUpdate={setShowUpdate}
      />
    );
  };

  return (
    <MainContainer>
      <BackLink onClick={() => navigate(`/fulfillments`)}>
        Back To Fulfillments
      </BackLink>

      {loading ? <Spinner /> : renderContent()}
    </MainContainer>
  );
};

export default FulfillmentPage;